
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { forgotPageLoad, forgotEnterEmail, forgotPassword } from 'actions'
import Forgot from '../components/Forgot'

class ForgotApp extends Component {
  render () {
    return React.createElement(Forgot, this.props)
  }

  componentDidMount () {
    this.props.onPageLoad()
  }
}

function mapStateToProps (state) {
  return state.application.forgot
}

function mapDispatchToProps (dispatch) {
  return {
    onPageLoad: () => dispatch(forgotPageLoad()),
    onEnterEmail: email => dispatch(forgotEnterEmail(email)),
    onSubmit: email => dispatch(forgotPassword(email))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotApp)



// WEBPACK FOOTER //
// ./containers/ForgotApp.js